<template>
  <div class="product-explore">
    <div class="category-tabs">
      <button
        v-for="category in categories"
        :key="category.id"
        type="button"
        :class="['category-tab', { active: currentCategory === category.id }]"
        @click="currentCategory = category.id"
      >
        {{ category.name }}
      </button>
    </div>

    <ul class="product-grid">
      <li class="product-card" v-for="product in currentProducts" :key="product.id">
        <div class="product-image">
          <img :src="product.image" :alt="product.title" loading="lazy" width="300" height="200">
        </div>
        <div class="product-info">
          <h3>
            <a v-if="hasDetail(product)" :href="detailHref(product)">{{ product.title }}</a>
            <template v-else>{{ product.title }}</template>
          </h3>
          <p class="description">{{ product.description }}</p>
          <a v-if="hasDetail(product)" class="explore-btn" :href="detailHref(product)">查看详情</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { products, productCategories, showcasedProductIds } from '@/config/products';

export default {
  name: 'ProductExplore',
  data() {
    return {
      currentCategory: 'shihu',
      categories: productCategories
    }
  },
  computed: {
    currentProducts() {
      return products[this.currentCategory] || [];
    }
  },
  methods: {
    /**
     * @param {{ id: string }} product
     * @returns {boolean}
     */
    hasDetail(product) {
      return showcasedProductIds.includes(product.id);
    },
    /**
     * @param {{ id: string }} product
     * @returns {string}
     */
    detailHref(product) {
      return `/products/${product.id}.html`;
    }
  }
}
</script>

<style scoped>
.category-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 0 0 14px;
}

.category-tab {
  padding: 8px 16px;
  border: 2px solid #4b0082;
  border-radius: 30px;
  background: transparent;
  color: #4b0082;
  font-size: 0.92em;
  cursor: pointer;
}

.category-tab.active {
  background: #4b0082;
  color: #fff;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.product-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.08);
}

.product-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #f5f0ff;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  padding: 14px;
}

.product-info h3 {
  color: #4b0082;
  font-size: 1.02em;
  margin: 0 0 6px;
}

.product-info h3 a {
  color: #4b0082;
  text-decoration: none;
}

.product-info h3 a:hover {
  text-decoration: underline;
}

.description {
  color: #666;
  font-size: 0.9em;
  line-height: 1.6;
  margin: 0 0 10px;
}

.explore-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 18px;
  border-radius: 24px;
  background: #4b0082;
  color: #fff;
  text-decoration: none;
  font-size: 0.92em;
}
</style>
